import { CoreApplicationContext } from '@eventbrite/context-gen';
import { parseLocationResponse } from '@eventbrite/redux-destination';
import { $FixMe } from '@eventbrite/ts-utils';
import { StringifyQuery } from 'react-router';
import { FacebookOptions } from '../../types/App';
import { Branding, FeatureFlags, PlaceObject } from '../../types/index';
import { getPageDescription } from '../../utils/general';
import {
    transformBrandingResponse,
    transformSearchBucketContent,
} from '../../utils/transformation';
import { parseSuggestions } from '../utils/suggestions';

interface getInitialDataProps {
    placeId?: string;
    latitude?: number;
    longitude?: number;
    description?: string;
    isBotRequest?: boolean;
    facebookOptions?: FacebookOptions;
    featureFlags?: FeatureFlags;
    gaSettings?: any;
    currentPlace?: string;
    buckets?: any;
    currentPlaceParent?: string;
    branding?: Branding;
    locations?: {
        places: PlaceObject[];
    };
    suggestions?: $FixMe;
    experiments?: any;
    guest_id?: string;
    location_slug?: string;
    search_id?: string;
    search_data?: { [index: string]: object };
    all_events_url?: string;
    http_referer?: StringifyQuery;
    trending_search_cities?: string[][];
    current_location_coordinates?: { latitude: number; longitude: number };
    place_type?: string;
    user: {
        isAuthenticated?: boolean;
        publicId?: string;
        email?: string;
        isStaff?: boolean;
    };
    request: { session_id: string };
    env: CoreApplicationContext['env'];
    category_article_mapping?: $FixMe;
    h1_prefix?: string;
    is_online?: boolean;
    botH1?: string;
    google_maps_api_key?: string;
    should_show_trending_search_page_link?: boolean;
    isGDPRCountry?: boolean;
}

export const getInitialData = (props: getInitialDataProps) => {
    const {
        placeId,
        latitude,
        longitude,
        description,
        isBotRequest,
        facebookOptions,
        featureFlags,
        gaSettings,
        currentPlace,
        buckets,
        currentPlaceParent,
        branding = {},
        locations = {},
        suggestions = {},
        experiments = {},
        guest_id: guestId,
        location_slug: slug,
        search_id: searchId,
        search_data: searchData,
        all_events_url: allEventsUrl,
        http_referer: httpReferer,
        trending_search_cities: trendingSearchCities,
        current_location_coordinates: currentLocationCoordinates,
        place_type: placeType,
        user: { isAuthenticated, publicId, email: userEmail, isStaff },
        request: { session_id: sessionId },
        env: {
            isMobile,
            localeInfo: {
                // every locale can use a different twitter account and
                // facebook account, so we need to use them in order to build
                // share messages
                twitter_handle: twitterHandle,
                facebook_locale: facebookLocale,
                facebook_page: facebookPage,
                google_maps_language: googleMapsLanguage,
                country_code: countryCode,
                language_code: languageCode,
                tld,
            },
            serverUrl,
            currencyFormat,
            ebDomain: domain,
        },
        category_article_mapping: categoryArticleMapping,
        h1_prefix: h1Prefix,
        is_online: isOnline,
        botH1,
        google_maps_api_key: googleMapsApiKey,
        should_show_trending_search_page_link: shouldShowTrendingSearchPageLink,
        isGDPRCountry,
    } = props;

    const {
        entities,
        entityContext,
        pagination,
        searchCriterias = {},
    } = transformSearchBucketContent(searchData);

    const cityBlurb =
        description || getPageDescription(currentPlace || '', buckets);

    return {
        pagination,
        currencyFormat,
        gaSettings,
        auth: {
            isAuthenticated,
        },
        location: {
            currentPlace,
            currentPlaceParent,
            cityBlurb,
            placeId,
            latitude,
            longitude,
            trendingSearchCities,
            currentLocationCoordinates,
            slug,
            placeType,
            topSuggestions: parseLocationResponse(locations),
            h1Prefix,
            isOnline,
        },
        content: {
            entities,
            entityContext,
            allEventsUrl,
            categoryArticleMapping,
        },
        share: {
            options: {
                isMobile,
                twitterHandle,
                serverUrl,
                facebookOptions: {
                    ...facebookOptions,
                    locale: facebookLocale,
                    page: facebookPage,
                },
            },
        },
        brand: transformBrandingResponse(branding, isOnline),
        suggestions: parseSuggestions(suggestions),
        search: {
            ...searchCriterias,
            searchId,
        },
        admin: {
            experimentOverride: {
                experimentName: Object.keys(experiments)[0],
                variant: experiments[Object.keys(experiments)[0]],
            },
        },
        app: {
            isBotRequest,
            sessionId,
            publicId,
            countryCode,
            googleMapsLanguage,
            httpReferer,
            domain,
            featureFlags,
            experiments,
            serverUrl,
            guestId,
            userEmail,
            languageCode,
            isGDPRCountry,
            tld,
        },
        botH1,
        googleMapsApiKey,
        user: {
            isStaff,
        },
        shouldShowTrendingSearchPageLink,
    };
};
